import MuiListItemIcon from '@material-ui/core/ListItemIcon';

export default MuiListItemIcon;
